import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class UtilsModule {

 static calculateTime(time) {
    let timeText = '--';
    if (!time) {
      return timeText;
    } else {
      const timeStamp = new Date().valueOf();
      const diff = (timeStamp - time)/ 1000; // 转换为秒
      if (diff < 60) {
        timeText = '刚才';
      } else if (diff >= 60 && diff < 3600) {
        const minutes = Math.floor(diff / 60); // 转换为分钟
        timeText = minutes + '分钟前';
      } else if (diff >= 3600 && diff < 86400) {
        const hours = Math.floor(diff / 3600); // 转换为小时
        timeText = hours + '小时前';
      } else if (diff >= 86400 && diff < 86400 * 7) {
        const days = Math.floor(diff / 86400); // 转换为天
        timeText = days + '天前';
      } else if (diff >= 86400 * 7 && diff < 86400 * 28) {
        const weeks = Math.floor(diff / 604800); // 转换为周
        timeText = weeks + '周前';
      } else if (diff >= 86400 * 28 && diff < 86400 * 30 * 12) {
        if (diff < 86400 * 30) {
          timeText = '1月前';
        } else {
          const months = Math.floor(diff / 2592000); // 转为为月(30天)
          timeText = months + '月前';
        }
      } else {
        const years = Math.floor(diff / 31104000); // 转换为年(360天)
        timeText = years + '年前';
      }
    }
    return timeText;
  }
  // 随机生成颜色
  getRandomColor() {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    const color = 'rgba(' + r + ',' + g + ',' + b + ')';
    return color;
  }
  // 格式化日期格式返回yyyy-mm-dd
  formatDateByGeneral(date) {
    if (date) {
      const y = date.getFullYear();
      let m = (date.getMonth() + 1).toString();
      m = m < 10 ? ('0' + m) : m.toString();
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d.toString();
      return y + '-' + m + '-' + d;
    }
  }
  // 格式化时间格式返回HH:mm:ss
  formatTimeByGeneral(date) {
    if (date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds;
      }
      return hours + ':' + minutes + ':' + seconds;
    }
  }
  // 格式化时间格式返回HH
  formatHoursByGeneral(date) {
    if (date) {
      let hours = date.getHours();
      if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
      }
      return hours;
    }
  }
  // 时间转毫秒
  formatTimeToSec(time) {
    const hour = time.split(':')[0];
    const min = time.split(':')[1];
    const sec = time.split(':')[2];
    const s = Number(hour * 3600) + Number(min * 60) + Number(sec);
    return s * 1000;
  }
  // 处理数组几个一组 [xx,xx,xx] -> [[],[]]
  handleArrayWrap(data, num): void {
    data.reduce((pre, next, idx) => {
      const inner = pre[~~(idx / num)];
      if (inner !== undefined) {
        inner.push(next);
      } else {
        pre.push([next]);
      }
      return pre;
    }, [[]]);
  }
  accMul(arg1, arg2) {
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
      m += s1.split('.')[1].length;
    } catch (e) {}
    try {
      m += s2.split('.')[1].length;
    } catch (e) {}
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)).toFixed(2);
  }
  // 时间戳转化成时间格式
  timeFormat(timestamp, type?) {
    const time = new Date(parseInt(timestamp));
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const date = time.getDate();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();
    if (type === 'yyyy-mm-dd') {
      return year + '-' + this.add0(month) + '-' + this.add0(date);
    } else {
      return year + '-' + this.add0(month) + '-' + this.add0(date) + ' ' + this.add0(hours) + ':' + this.add0(minutes) + ':' + this.add0(seconds);
    }
  }
  add0(m) {
    return m < 10 ? '0' + m : m;
  }
}
